import React, { Component } from 'react'
import View from './view'
import Success from './success'
import { passwordSatisfiesPolicy } from '../utils/passwordPolicyValidator'

class CompletePasswordReset extends Component {
  constructor(props) {
    super(props)
    
    this.state = {
      errors: {},
      loading: false,
      newPassword: '',
      success: false
    }
  }

  handleChange = (name, value) => {
    this.setState({ [name]: value })
  }

  handleSubmit = (event) => {
    event.preventDefault()
    this.setState({ errors: {} })

    if (!passwordSatisfiesPolicy(this.state.newPassword)) {        
      this.setState({errors: {
        newPassword: ['New Password does not meet requirements'],
        passwordPolicy: ['New Password does not meet requirements']
      }})
      return
    }

    this.sendPasswordChange(this.props.token, this.state.newPassword)
  }

  sendPasswordChange = (resetToken, newPassword) => {
    this.setState({ loading: true })
    return fetch(`${process.env.REACT_APP_API_HOST}/api/v1/set-new-password`,
      {
        method: 'POST',
        headers: new Headers({
          'content-type': 'application/json',
        }),
        body: JSON.stringify({ 'reset_token': resetToken, 'new_password': newPassword })
      })
      .then(resp => {
        if (!resp.ok) return Promise.reject(resp)
        return this.setState({ success: true })
      })
      .catch((err) => {
        if(err.status === 401) {
          return this.setState({errors: {
            summary: ['Your reset password link is invalid or expired. Please request a new password reset email.']
          }})
        }
        if(err.status === 400) {
          return this.setState({errors: {
            summary: ['Your password does not meet our password policy. Please use a different password.']
          }})
        }

        return this.setState({
          errors: {
            summary: ['We encountered an issue resetting your password. Please try again or contact support.']
          }
        })
      }).then(() => this.setState({ loading: false }))
  }

  render() {
    return(
      this.state.success ?
        <Success /> :
        <View
          errors={this.state.errors}
          loading={this.state.loading}
          newPassword={this.state.newPassword}
          handleSubmit={this.handleSubmit}
          handleChange={this.handleChange}
        />
    )
  }
}

export default CompletePasswordReset


// WEBPACK FOOTER //
// ./src/complete-password-reset/index.jsx